/** Fallback if controllerchange never fires after SKIP_WAITING. */
const RELOAD_FALLBACK_MS = 500;

/**
 * Activate the waiting service worker, then hard-reload.
 * vite-plugin-pwa's updateServiceWorker(true) ignores the reload flag in
 * prompt mode — it only posts SKIP_WAITING — so we reload ourselves.
 *
 * @param {(reloadPage?: boolean) => Promise<void>} updateServiceWorker
 */
export async function activateWaitingServiceWorker(updateServiceWorker) {
  let reloaded = false;
  const reloadOnce = () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  };

  if (navigator.serviceWorker) {
    navigator.serviceWorker.addEventListener("controllerchange", reloadOnce, {
      once: true,
    });
  }

  try {
    await updateServiceWorker(true);
  } catch (error) {
    console.error("Failed to activate waiting service worker:", error);
  }

  window.setTimeout(reloadOnce, RELOAD_FALLBACK_MS);
}
